import React, { useRef, useEffect } from "react";

const VideoPlayer = ({ videoUrl }) => {
  const playerRef = useRef(null);
  const previousUrlRef = useRef(videoUrl);

  useEffect(() => {
    // Only update if URL actually changed
    if (previousUrlRef.current !== videoUrl) {
      previousUrlRef.current = videoUrl;
    }
  }, [videoUrl]);

  return (
    <div className="absolute top-0 left-0 w-full h-full">
      <iframe
        ref={playerRef}
        src={videoUrl}
        className="w-full h-full"
        allow="autoplay; fullscreen"
        allowFullScreen
        title="Video Player"
      />
    </div>
  );
};

// Strict comparison of props
const MemoizedVideoPlayer = React.memo(VideoPlayer, (prevProps, nextProps) => {
  return prevProps.videoUrl === nextProps.videoUrl;
});

export default MemoizedVideoPlayer;
